<template>
    <link-dialog v-model="p_show"
                 title="数据筛选排序"
                 destroyOnHide
                 confirmButton
                 cancelButton
                 width="400px"
                 :loading="loading"
                 @confirm="lv_confirm"
                 @cancel="lv_cancel">
        <div class="link-sort-filter-dialog">
            <article v-if="!!col">
                <template v-if="!!col.sort">
                    <section class="link-sort-filter-dialog-title">
                        <span>排序</span>
                    </section>
                    <section class="link-sort-filter-dialog-edit link-sort-filter-dialog-edit-sort">
                        <div :class="{'link-sort-filter-dialog-edit-sort-active':sortValue === 'asc'}" @click="sortValue = 'asc'">
                            <div class="link-sort-filter-dialog-edit-sort-tag">
                                <div class="link-sort-filter-dialog-edit-sort-tag-letter">
                                    <span class="link-sort-filter-dialog-edit-sort-tag-letter-active">A</span>
                                    <span>Z</span>
                                </div>
                                <link-icon icon="icon-arrow-down"/>
                            </div>
                            <span>升序</span>
                        </div>
                        <div :class="{'link-sort-filter-dialog-edit-sort-active':sortValue === 'desc'}" @click="sortValue = 'desc'">
                            <div class="link-sort-filter-dialog-edit-sort-tag">
                                <div class="link-sort-filter-dialog-edit-sort-tag-letter">
                                    <span>Z</span>
                                    <span class="link-sort-filter-dialog-edit-sort-tag-letter-active">A</span>
                                </div>
                                <link-icon icon="icon-arrow-down"/>
                            </div>
                            <span>降序</span>
                        </div>
                        <div :class="{'link-sort-filter-dialog-edit-sort-active':sortValue === ''}" @click="sortValue = ''">不排序</div>
                    </section>
                </template>

                <template v-if="col.search">
                    <section class="link-sort-filter-dialog-title">
                        <span>搜索</span>
                    </section>
                    <section class="link-sort-filter-dialog-edit">
                        <link-dynamic-filter :value="searchDynamicFilter" searchIcon width="100%" ref="search" @change="lv_searchConfirm"/>
                    </section>
                </template>

                <template v-if="col.columnFilter">
                    <section class="link-sort-filter-dialog-title">
                        <span>筛选</span>
                    </section>
                    <section>
                        <link-input long prefixIcon="link-icon-search" v-model="filterText" @enter="lv_searchFilterList" @click-suffix-icon="lv_clear" :placeholder="$t('LinkFilter.filterKey')+'...'"/>
                        <div class="link-sort-filter-dialog-content" v-if="!!option">
                            <link-table :data="linkSelectFilterData"
                                        @vertical-scroll-bottom="lv_verticalScrollBottom"
                                        :rowNum="6"
                                        :rowHeight="24">
                                <link-table-column-check selectCache ref="check"/>
                                <link-table-column title="全选" field="text" tooltip :sort="false"/>
                            </link-table>
                        </div>
                    </section>
                </template>
            </article>

        </div>
    </link-dialog>
</template>

<script>
    import {LinkSelectFilter} from "./link-sort-filter-service";

    export default {
        name: "link-sort-filter-dialog",
        data() {
            return {
                p_show: false,

                col: null,                          //列信息对象
                option: null,                       //autoTable的option参数
                onConfirm: null,                    //确认操作
                onCancel: null,                     //取消操作

                sortValue: null,                    //排序方式
                loading: false,                     //当前是否处于加载中状态
                linkSelectFilterData: [],                           //表格数组
                total: null,                        //总数据条数
                filterText: null,                   //筛选列表查询关键字
                searchDynamicFilter: null,          //搜索绑定值
                param: {
                    distinctFields: null,           //去重的字段数组
                    page: 1,                        //当前查询页
                    rows: 20,                       //每页返回数据长度
                },
            }
        },
        computed: {
            field() {
                return !!this.col && this.col.searchField ? this.col.searchField : this.col.field ? this.col.field : null
            },
            title() {
                return !!this.col ? this.col.title : null
            },
            columnParam() {
                return this.option.columnParams[this.field]
            },
        },
        methods: {
            /**
             * 打开筛选对话框
             * @author  韦胜健
             * @date    2019/9/23 17:18
             */
            show({option, col, onConfirm, onCancel}) {
                Object.assign(this, {option, col, onConfirm, onCancel})
                this.lv_resetParam()
                if (!!col.columnFilter) this.lv_reload()
                this.p_show = true
            },
            /**
             * 筛选确认操作
             * @author  韦胜健
             * @date    2019/9/23 15:13
             */
            lv_confirm() {
                if (!!this.$refs.search) this.$refs.search.getValue()
                const linkSelectFilterData = this.$refs.check.getSelectedRows()
				!!this.onConfirm && this.onConfirm({
                    col: this.col,
                    linkSelectFilterData: linkSelectFilterData,                     //选择筛选数据
                    searchDynamicFilter: this.searchDynamicFilter,                  //搜索框绑定值
                    sortValue: this.sortValue,                                      //排序方式
                })
            },
            /**
             * 筛选取消操作
             * @author  韦胜健
             * @date    2019/9/23 15:13
             */
            lv_cancel() {
                !!this.onCancel && this.onCancel()
            },
            /**
             * 重设请求额外参数
             * @author  韦胜健
             * @date    2019/9/23 15:13
             */
            lv_resetParam() {
                this.filterText = null
                this.sortValue = null

                this.param = {
                    distinctFields: this.field,
                    page: 1,
                    rows: 20,
                    sort: this.field,
                    order: 'desc',
                }
				const linkFilterOption = this.option.lv_linkFilterOptionsMap[this.col.searchField ? this.col.searchField : this.col.field]
                if (!linkFilterOption) {
                    console.log(this)
                    console.error('列筛选异常，找不到linkFilterOption')
                }
                this.searchDynamicFilter = new DynamicFilter(linkFilterOption)
                this.linkSelectFilterData = []

                if (this.option.sortField === this.field) this.sortValue = this.option.sortDesc ? 'desc' : 'asc'
            },
            /**
             * 监听滚动到底部事件
             * @author  韦胜健
             * @date    2019/9/23 14:21
             */
            lv_verticalScrollBottom() {
                this.lv_loadNext()
            },
            /**
             * 加载数据
             * @author  韦胜健
             * @date    2019/9/23 17:18
             */
            async lv_load() {

                /*从autoOption中获取查询参数，排除列筛选为当前列的筛选参数，获取完筛选参数之后，将筛选参数放回去*/
                const oldValue = this.option.columnParams[this.field]
                if (!!oldValue) delete this.option.columnParams[this.field]
                const queryParam = await this.option.getQueryParam()
                if (!!oldValue) this.$set(this.option.columnParams, this.field, oldValue)

                /*请求参数*/
                const requestOption = {
                    url: this.option._queryByExamplePage,
                    param: queryParam,
                    requestMethod: this.option.requestMethod,
                    formatFormParam: this.option.formatFormParamSetting.queryByExamplePage,
                }
                Object.assign(requestOption.param, this.param)
				if (!!this.filterText) {
					if (!requestOption.param.filtersRaw) requestOption.param.filtersRaw = []
					const id = `column_${this.field}`
					const filtersRaw = !!this.col.getFiltersRawBySortFilterText ? await this.col.getFiltersRawBySortFilterText(this.filterText) : {
						value: this.filterText,
						operator: 'like'
					}
					// console.log(filtersRaw)
					filtersRaw.id = id
					filtersRaw.property = this.field

					requestOption.param.filtersRaw.push(filtersRaw)
					if (!!requestOption.param.filterOperator) requestOption.param.filterOperator = `(${requestOption.param.filterOperator} and ${id} )`
				}

                // delete requestOption.param.sort
                // delete requestOption.param.order

                !!this.option.beforeLoad && (await this.option.beforeLoad.apply(this.option.context, [requestOption]))

                try {
                    this.loading = true
                    const data = await this.option._request(requestOption)
                    let {rows, total} = data
                    this.option._executeRowFormatter(rows, 'afterLoad')
                    const ret = []
                    /*检测是否已经存在"空值"筛选选项*/
                    let isNull = false
                    for (let i = 0; i < rows.length; i++) {
                        const row = rows[i]
                        if (!row || row[this.field] == null || row[this.field] === '') {
                            if (!isNull) {
                                isNull = true
                                ret.push(new LinkSelectFilter({value: 'null', text: '空值',}))
                            }
                        } else {
                            let value = row[this.field]
                            ret.push(new LinkSelectFilter({
                                value: value,
                                text: !!this.col.translate ? await this.col.translate(value) : value,
                            }))
                        }
                    }
                    this.linkSelectFilterData.push(...ret)
                    !!this.option.afterLoad && this.option.afterLoad.apply(this.option.context, [rows, requestOption, data])
                    this.total = total
                } catch (e) {
                } finally {
                    this.loading = false
                }
            },
            /**
             * 加载下一页数据
             * @author  韦胜健
             * @date    2019/9/23 17:19
             */
            async lv_loadNext() {
                if ((this.param.page - 1) * this.param.rows >= this.total) return
                this.param.page++
                this.lv_load()
            },
            /**
             * 重新加载数据
             * @author  韦胜健
             * @date    2019/9/23 17:19
             */
            async lv_reload() {
                this.param.page = 1
                this.linkSelectFilterData = []
                this.lv_load()
            },
            /**
             * 清除关键字，重新加载数据
             * @author  韦胜健
             * @date    2019/9/23 17:19
             */
            async lv_clear() {
                this.filterText = null
                this.lv_reload()
            },
            /**
             * 根据关键字筛选数据
             * @author  韦胜健
             * @date    2019/9/23 17:19
             */
            lv_searchFilterList(e) {
                this.filterText = e.target.value
                this.lv_reload()
            },
            /**
             * 搜索确认动作
             * @author  韦胜健
             * @date    2019/9/29 11:42
             */
            lv_searchConfirm() {
                if (this.searchDynamicFilter.type === 'input') {
                    this.lv_confirm()
                    this.p_show = false
                }
            },
        },
    }
</script>

<style lang="scss">
    @include themeify {
        .link-sort-filter-dialog {
            width: 100%;
            box-sizing: border-box;
            padding: 0 12px;

            .link-sort-filter-dialog-title {
                color: black;
                margin-bottom: 8px;
                font-size: 14px;
            }

            .link-sort-filter-dialog-edit {
                margin-bottom: 12px;
            }

            input {
                padding-left: 0 !important;
            }

            .link-sort-filter-dialog-content {
                margin-top: 8px;

                .lv-base-table {
                    .lv-table-head {
                        border-bottom: none;
                        font-weight: normal !important;

                        .lv-table-head-item {
                            background-color: white;
                        }
                    }

                    .lv-table-cell {
                        font-weight: normal !important;
                        border-bottom: none !important;
                        padding-left: 0 !important;
                    }
                }
            }

            .link-sort-filter-dialog-edit-sort {
                display: flex;
                justify-content: space-between;

                & > div {
                    width: 31.5%;
                    height: 28px;
                    background-color: #f9f9f9;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-sizing: border-box;

                    color: #666;
                    font-size: 12px;
                    border: solid 1px #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                    position: relative;

                    &:hover, &.link-sort-filter-dialog-edit-sort-active {
                        background-color: #e2e2e2;
                    }

                    .link-sort-filter-dialog-edit-sort-tag {
                        position: absolute;
                        display: flex;
                        align-items: center;
                        left: 6px;
                        top: -2px;

                        .link-sort-filter-dialog-edit-sort-tag-letter {
                            display: flex;
                            flex-direction: column;
                            font-size: 12px;
                            transform: scale(0.75);

                            .link-sort-filter-dialog-edit-sort-tag-letter-active {
                                color: pl-var(color-primary);
                            }
                        }
                    }
                }
            }
        }
    }
</style>
